/**
 * Curated list of commonly used timezones, matching the server's list.
 * Each entry has { name, offset, label } where offset is UTC offset in minutes.
 * Sorted by offset then name.
 */
const timezones = [
  // UTC-10
  {
    name: "Pacific/Honolulu",
    offset: -600,
    label: "Pacific/Honolulu (UTC-10:00)",
  },
  // UTC-09
  {
    name: "America/Anchorage",
    offset: -540,
    label: "America/Anchorage (UTC-09:00)",
  },
  // UTC-08
  {
    name: "America/Los_Angeles",
    offset: -480,
    label: "America/Los_Angeles (UTC-08:00)",
  },
  {
    name: "America/Vancouver",
    offset: -480,
    label: "America/Vancouver (UTC-08:00)",
  },
  // UTC-07
  { name: "America/Denver", offset: -420, label: "America/Denver (UTC-07:00)" },
  {
    name: "America/Phoenix",
    offset: -420,
    label: "America/Phoenix (UTC-07:00)",
  },
  // UTC-06
  {
    name: "America/Chicago",
    offset: -360,
    label: "America/Chicago (UTC-06:00)",
  },
  {
    name: "America/Mexico_City",
    offset: -360,
    label: "America/Mexico_City (UTC-06:00)",
  },
  // UTC-05
  { name: "America/Bogota", offset: -300, label: "America/Bogota (UTC-05:00)" },
  { name: "America/Lima", offset: -300, label: "America/Lima (UTC-05:00)" },
  {
    name: "America/New_York",
    offset: -300,
    label: "America/New_York (UTC-05:00)",
  },
  {
    name: "America/Toronto",
    offset: -300,
    label: "America/Toronto (UTC-05:00)",
  },
  // UTC-04
  {
    name: "America/Halifax",
    offset: -240,
    label: "America/Halifax (UTC-04:00)",
  },
  {
    name: "America/Santiago",
    offset: -240,
    label: "America/Santiago (UTC-04:00)",
  },
  // UTC-03
  {
    name: "America/Argentina/Buenos_Aires",
    offset: -180,
    label: "America/Argentina/Buenos_Aires (UTC-03:00)",
  },
  {
    name: "America/Sao_Paulo",
    offset: -180,
    label: "America/Sao_Paulo (UTC-03:00)",
  },
  // UTC+00
  { name: "Africa/Abidjan", offset: 0, label: "Africa/Abidjan (UTC+00:00)" },
  { name: "Africa/Accra", offset: 0, label: "Africa/Accra (UTC+00:00)" },
  { name: "Europe/Dublin", offset: 0, label: "Europe/Dublin (UTC+00:00)" },
  { name: "Europe/Lisbon", offset: 0, label: "Europe/Lisbon (UTC+00:00)" },
  { name: "Europe/London", offset: 0, label: "Europe/London (UTC+00:00)" },
  { name: "UTC", offset: 0, label: "UTC (UTC+00:00)" },
  // UTC+01
  { name: "Africa/Algiers", offset: 60, label: "Africa/Algiers (UTC+01:00)" },
  {
    name: "Africa/Casablanca",
    offset: 60,
    label: "Africa/Casablanca (UTC+01:00)",
  },
  { name: "Africa/Douala", offset: 60, label: "Africa/Douala (UTC+01:00)" },
  { name: "Africa/Lagos", offset: 60, label: "Africa/Lagos (UTC+01:00)" },
  { name: "Africa/Kinshasa", offset: 60, label: "Africa/Kinshasa (UTC+01:00)" },
  { name: "Africa/Luanda", offset: 60, label: "Africa/Luanda (UTC+01:00)" },
  { name: "Africa/Tunis", offset: 60, label: "Africa/Tunis (UTC+01:00)" },
  {
    name: "Europe/Amsterdam",
    offset: 60,
    label: "Europe/Amsterdam (UTC+01:00)",
  },
  { name: "Europe/Berlin", offset: 60, label: "Europe/Berlin (UTC+01:00)" },
  { name: "Europe/Brussels", offset: 60, label: "Europe/Brussels (UTC+01:00)" },
  { name: "Europe/Budapest", offset: 60, label: "Europe/Budapest (UTC+01:00)" },
  { name: "Europe/Madrid", offset: 60, label: "Europe/Madrid (UTC+01:00)" },
  { name: "Europe/Oslo", offset: 60, label: "Europe/Oslo (UTC+01:00)" },
  { name: "Europe/Paris", offset: 60, label: "Europe/Paris (UTC+01:00)" },
  { name: "Europe/Prague", offset: 60, label: "Europe/Prague (UTC+01:00)" },
  { name: "Europe/Rome", offset: 60, label: "Europe/Rome (UTC+01:00)" },
  {
    name: "Europe/Stockholm",
    offset: 60,
    label: "Europe/Stockholm (UTC+01:00)",
  },
  { name: "Europe/Vienna", offset: 60, label: "Europe/Vienna (UTC+01:00)" },
  { name: "Europe/Warsaw", offset: 60, label: "Europe/Warsaw (UTC+01:00)" },
  { name: "Europe/Zurich", offset: 60, label: "Europe/Zurich (UTC+01:00)" },
  // UTC+02
  {
    name: "Africa/Blantyre",
    offset: 120,
    label: "Africa/Blantyre (UTC+02:00)",
  },
  {
    name: "Africa/Bujumbura",
    offset: 120,
    label: "Africa/Bujumbura (UTC+02:00)",
  },
  { name: "Africa/Cairo", offset: 120, label: "Africa/Cairo (UTC+02:00)" },
  { name: "Africa/Harare", offset: 120, label: "Africa/Harare (UTC+02:00)" },
  {
    name: "Africa/Johannesburg",
    offset: 120,
    label: "Africa/Johannesburg (UTC+02:00)",
  },
  { name: "Africa/Kigali", offset: 120, label: "Africa/Kigali (UTC+02:00)" },
  {
    name: "Africa/Lubumbashi",
    offset: 120,
    label: "Africa/Lubumbashi (UTC+02:00)",
  },
  { name: "Africa/Lusaka", offset: 120, label: "Africa/Lusaka (UTC+02:00)" },
  { name: "Africa/Maputo", offset: 120, label: "Africa/Maputo (UTC+02:00)" },
  {
    name: "Africa/Windhoek",
    offset: 120,
    label: "Africa/Windhoek (UTC+02:00)",
  },
  { name: "Asia/Beirut", offset: 120, label: "Asia/Beirut (UTC+02:00)" },
  { name: "Asia/Jerusalem", offset: 120, label: "Asia/Jerusalem (UTC+02:00)" },
  { name: "Europe/Athens", offset: 120, label: "Europe/Athens (UTC+02:00)" },
  {
    name: "Europe/Bucharest",
    offset: 120,
    label: "Europe/Bucharest (UTC+02:00)",
  },
  {
    name: "Europe/Helsinki",
    offset: 120,
    label: "Europe/Helsinki (UTC+02:00)",
  },
  { name: "Europe/Kyiv", offset: 120, label: "Europe/Kyiv (UTC+02:00)" },
  // UTC+03
  {
    name: "Africa/Addis_Ababa",
    offset: 180,
    label: "Africa/Addis_Ababa (UTC+03:00)",
  },
  {
    name: "Africa/Dar_es_Salaam",
    offset: 180,
    label: "Africa/Dar_es_Salaam (UTC+03:00)",
  },
  { name: "Africa/Kampala", offset: 180, label: "Africa/Kampala (UTC+03:00)" },
  { name: "Africa/Nairobi", offset: 180, label: "Africa/Nairobi (UTC+03:00)" },
  { name: "Asia/Baghdad", offset: 180, label: "Asia/Baghdad (UTC+03:00)" },
  { name: "Asia/Istanbul", offset: 180, label: "Asia/Istanbul (UTC+03:00)" },
  { name: "Asia/Riyadh", offset: 180, label: "Asia/Riyadh (UTC+03:00)" },
  { name: "Europe/Moscow", offset: 180, label: "Europe/Moscow (UTC+03:00)" },
  // UTC+03:30
  { name: "Asia/Tehran", offset: 210, label: "Asia/Tehran (UTC+03:30)" },
  // UTC+04
  { name: "Asia/Dubai", offset: 240, label: "Asia/Dubai (UTC+04:00)" },
  // UTC+04:30
  { name: "Asia/Kabul", offset: 270, label: "Asia/Kabul (UTC+04:30)" },
  // UTC+05
  { name: "Asia/Karachi", offset: 300, label: "Asia/Karachi (UTC+05:00)" },
  // UTC+05:30
  { name: "Asia/Colombo", offset: 330, label: "Asia/Colombo (UTC+05:30)" },
  { name: "Asia/Kolkata", offset: 330, label: "Asia/Kolkata (UTC+05:30)" },
  // UTC+05:45
  { name: "Asia/Kathmandu", offset: 345, label: "Asia/Kathmandu (UTC+05:45)" },
  // UTC+06
  { name: "Asia/Dhaka", offset: 360, label: "Asia/Dhaka (UTC+06:00)" },
  // UTC+07
  { name: "Asia/Bangkok", offset: 420, label: "Asia/Bangkok (UTC+07:00)" },
  {
    name: "Asia/Ho_Chi_Minh",
    offset: 420,
    label: "Asia/Ho_Chi_Minh (UTC+07:00)",
  },
  { name: "Asia/Jakarta", offset: 420, label: "Asia/Jakarta (UTC+07:00)" },
  // UTC+08
  { name: "Asia/Hong_Kong", offset: 480, label: "Asia/Hong_Kong (UTC+08:00)" },
  {
    name: "Asia/Kuala_Lumpur",
    offset: 480,
    label: "Asia/Kuala_Lumpur (UTC+08:00)",
  },
  { name: "Asia/Manila", offset: 480, label: "Asia/Manila (UTC+08:00)" },
  { name: "Asia/Shanghai", offset: 480, label: "Asia/Shanghai (UTC+08:00)" },
  { name: "Asia/Singapore", offset: 480, label: "Asia/Singapore (UTC+08:00)" },
  { name: "Asia/Taipei", offset: 480, label: "Asia/Taipei (UTC+08:00)" },
  {
    name: "Australia/Perth",
    offset: 480,
    label: "Australia/Perth (UTC+08:00)",
  },
  // UTC+09
  { name: "Asia/Seoul", offset: 540, label: "Asia/Seoul (UTC+09:00)" },
  { name: "Asia/Tokyo", offset: 540, label: "Asia/Tokyo (UTC+09:00)" },
  // UTC+09:30
  {
    name: "Australia/Adelaide",
    offset: 570,
    label: "Australia/Adelaide (UTC+09:30)",
  },
  {
    name: "Australia/Darwin",
    offset: 570,
    label: "Australia/Darwin (UTC+09:30)",
  },
  // UTC+10
  {
    name: "Australia/Brisbane",
    offset: 600,
    label: "Australia/Brisbane (UTC+10:00)",
  },
  {
    name: "Australia/Melbourne",
    offset: 600,
    label: "Australia/Melbourne (UTC+10:00)",
  },
  {
    name: "Australia/Sydney",
    offset: 600,
    label: "Australia/Sydney (UTC+10:00)",
  },
  // UTC+12
  {
    name: "Pacific/Auckland",
    offset: 720,
    label: "Pacific/Auckland (UTC+12:00)",
  },
  { name: "Pacific/Fiji", offset: 720, label: "Pacific/Fiji (UTC+12:00)" },
];

export default timezones;
